import { apiGet } from '@/shared/utils/requestBuilder';

import type {
  DocumentoAssinadoArDto,
  EnvioFisicoArDocumentoAssinavel,
  ListaEnviosFisicosArDto,
} from '../../types/envioFisicoArTypes';
import { lerDadosDaRespostaDoCore } from '@/shared/utils/respostaDoCore';

const BASE = (processoArbitralId: string) => `/arbitral/processos/${processoArbitralId}/ar/envios`;

/**
 * Cartas por página. Explícito, e não o default do servidor: o "Carregar mais" depende de
 * `hasMore`, e um default que mudasse no core mudaria em silêncio quantas cartas a aba
 * mostra antes do botão.
 */
const ENVIOS_FISICOS_POR_PAGINA = 10;

export const envioFisicoArService = {
  listar: async (processoArbitralId: string, page: number): Promise<ListaEnviosFisicosArDto> =>
    lerDadosDaRespostaDoCore(
      await apiGet(`${BASE(processoArbitralId)}?page=${page}&limit=${ENVIOS_FISICOS_POR_PAGINA}`),
      'Não foi possível carregar o envio físico',
    ),

  /** Link assinado, curto (minutos): pedido no clique, nunca guardado. */
  documento: async (
    processoArbitralId: string,
    envioFisicoId: string,
    tipo: EnvioFisicoArDocumentoAssinavel,
  ): Promise<DocumentoAssinadoArDto> =>
    lerDadosDaRespostaDoCore(
      await apiGet(`${BASE(processoArbitralId)}/${envioFisicoId}/documentos/${tipo}`),
      'Não foi possível abrir o documento',
    ),
};
